import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from '../_services/auth.service';
import { getPrivateWebAddress } from './util.helper';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  private_web_address: string = ''
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.authService.isLoggedIn()) {
      return true;
    }
    else {
      this.private_web_address = getPrivateWebAddress();
      // return this.authService.signInOnlyPwa(this.private_web_address).subscribe(
      //  result => {
      //     // Successful login (token exists and no error)
      //     if (result && !result.error && result.token) {
      //       return true;
      //     }
      //     // Failed login - redirect to login page
      //     document.location.reload();
      //   }
      // );
      return true;
    }
  }
}
